import React from 'react';
import PropTypes from 'prop-types';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Divider from '@mui/material/Divider';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import ParentBatchDetailsContent from './ParentBatchDetailsContent';

const ParentBatchSummary = ({ totalProposedVolume }) => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'), { noSsr: true });
  const theme = useTheme();

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      {isMobile ? (
        <Accordion defaultExpanded sx={{ width: '100%' }}>
          <AccordionSummary
            aria-controls="parent-batch-details-content"
            expandIcon={<ExpandMoreIcon sx={{ color: 'primary.main' }} />}
            id="parent-batch-details-header"
          >
            <Typography variant="body2">Batch Details</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <ParentBatchDetailsContent totalProposedVolume={totalProposedVolume} />
          </AccordionDetails>
        </Accordion>
      ) : (
        <Card elevation={1} sx={{ width: { lg: '250px', sm: '100%' } }}>
          <CardHeader
            slotProps={{
              title: theme.typography.body2,
            }}
            title="Batch Details"
          />
          <Divider />
          <CardContent sx={{ backgroundColor: 'surface.light' }}>
            <ParentBatchDetailsContent totalProposedVolume={totalProposedVolume} />
          </CardContent>
        </Card>
      )}
    </Box>
  );
};

ParentBatchSummary.propTypes = {
  totalProposedVolume: PropTypes.number.isRequired,
};

export default ParentBatchSummary;
